import { FilterStoreHook } from 'libs/end-to-end/src/filters-v2/types/filters-v2.types';
import { getSelectedStringValuePrimaryFilterFromStore } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { PrimaryFilterSelection } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { FiltersFeatureName } from 'libs/end-to-end/src/filters-v2/filter-utils';
import React, { useMemo } from 'react';
import { FilterListBox } from 'apps/sigma2-ui/src/filters-v2/components/FilterListBox';
import { FilterListBoxItem } from 'apps/sigma2-ui/src/filters-v2/components/FilterListBox';
import { FocusArea } from 'libs/end-to-end/src/focus-area';
import { Box } from 'apps/sigma2-ui/src/components/ui/Box';
import { BigTimePeriodComparison } from 'libs/end-to-end/src/big-time-period-comparison';
import { BigTimePeriodComparisonDropdownOptions } from 'libs/end-to-end/src/big-time-period-comparison';

export const BigTimePeriodComparisonMenu = ({
  store,
  feature,
  databaseRevisionId,
  databaseId,
  organizationId,
  closeMenu,
  setPrimaryFilters,
  focusArea,
  analysisName,
}: {
  store: FilterStoreHook;
  feature: FiltersFeatureName;
  organizationId: string;
  databaseId: string;
  databaseRevisionId: string;
  closeMenu: () => void;
  setPrimaryFilters: (params: {
    selections: PrimaryFilterSelection[];
    shouldPreventAutoSubmit?: boolean;
  }) => void;
  focusArea: FocusArea | null;
  analysisName: string | undefined;
}) => {
  const items: FilterListBoxItem[] = useMemo(() => {
    const currentGroupByStr = getSelectedStringValuePrimaryFilterFromStore({
      feature,
      organizationId,
      databaseRevisionId,
      databaseId,
      store,
      focusArea,
      analysisName,
      primaryFilterKey: 'bigTimePeriodComparison',
    });

    const typedGroupBy = BigTimePeriodComparison.safeParse(currentGroupByStr);
    const finalGroupBy = typedGroupBy.success
      ? typedGroupBy.data === 'none'
        ? null
        : typedGroupBy.data
      : null;

    return BigTimePeriodComparisonDropdownOptions.map((item) => ({
      value: item.optionValue,
      translatedContent: item.optionLabel,
      selected: item.optionValue === finalGroupBy,
    }));
  }, [
    feature,
    organizationId,
    databaseRevisionId,
    databaseId,
    store,
    focusArea,
    analysisName,
  ]);

  return (
    <Box bg={'white'} w={'48'}>
      <FilterListBox
        multiple={false}
        items={items}
        onUpdate={({ addedSelections }) => {
          const primaryFiltersSelections: PrimaryFilterSelection[] = [
            {
              primaryFilterKey: 'bigTimePeriodComparison',
              value: addedSelections[0],
            },
          ];

          setPrimaryFilters({ selections: primaryFiltersSelections });

          closeMenu();
        }}
      />
    </Box>
  );
};
